var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snbt"},[_c('div',{staticClass:"bg"}),_c('div',[_vm._v("正在努力开发中......")])])
}]

export { render, staticRenderFns }